export default "__VITE_ASSET__xWgg07dp__"